import { type ReactElement } from 'react';
import { sgwtConnect } from '@/sgwt/sgwtConnect.ts';
import { HealthVisualize} from '../components/health/healthVisualize.tsx'
import { Home} from '../components/home/home.tsx'

export function HealthPage(): ReactElement {

  if (sgwtConnect.isAuthorized())
    return <HealthVisualize/>;
  return <Home />
}